export const shortDrivingCategories = (drivingCategories) => {
  const modified: Array<{ label: string; value: number }> = [];
  const seen = new Set<number>();

  drivingCategories?.forEach((item) => {
    const primaryCategoryId = item.primaryCategoryId;
    if (primaryCategoryId && !seen.has(primaryCategoryId)) {
      seen.add(primaryCategoryId);
      modified.push({
        label: item.primaryCategoryName || item.label.substring(0, 1),
        value: primaryCategoryId,
      });
    }
  });

  return modified;
};